export const CHAT_DEF_ID = '14517e1a-3ff0-af98-408e-2bd6953c36a2';
export const fallbackFont = 'HelveticaNeueW01-45Ligh';

export const ASCEND_LANDING_PAGE_URL =
  'https://www.wix.com/ascend/home?utm_campaign=vir_wixad_chat';

export const WINDOW_POSITION = {
  BOTTOM_RIGHT: '1',
  BOTTOM_LEFT: '2',
};

export const IMAGE_PREVIEW_MODAL_SIZE = {
  width: 1200,
  height: 800,
};
